import { CSSProperties, useMemo } from "react";
import { classNames } from "@ct-react/core";
import { Wrapper } from "../wrapper";
import "./page-hero.scss";

type Props = {
  className?: string;
  title?: string;
  chapo?: string;
  background?: string;
}

export const PageHero = ({ className, title, chapo, background }: Props) => {

  const styleProperties = useMemo(() => ({
    ...(!!background && { "--ccv-hero-bg-image": `url(${encodeURI(background)})` })
  } as CSSProperties), [ background ]);

  const wrapperClasses = classNames("main-hero", className);

  return (
    <Wrapper.Centered className={wrapperClasses}
                      style={styleProperties}>
      <div className="title-wrap">
        {!!title && <h1>{title}</h1>}
        {!!chapo && <p>{chapo}</p>}
      </div>
    </Wrapper.Centered>);

}

export default PageHero;
